import { __rest } from "tslib";
import { jsx as _jsx } from "react/jsx-runtime";
import { useFormContext, useWatch } from 'react-hook-form';
import { useFeatureToggle } from '../../../hooks/useFeatureToggle';
import { AddressFieldsBasicAlt } from './address-fields-basic-alt/AddressFieldsBasicAlt';
import { AddressFieldsBasic } from './address-fields-basic/AddressFieldsBasic';
import { AddressFieldsBE } from './address-fields-be/AddressFieldsBE';
import { AddressFieldsDE } from './address-fields-de/AddressFieldsDE';
import { AddressFieldsFR } from './address-fields-fr/AddressFieldsFR';
import { AddressFieldsLU } from './address-fields-lu/AddressFieldsLU';
import { AddressFieldsNL } from './address-fields-nl/AddressFieldsNL';
import { AddressFieldsUK } from './address-fields-uk/AddressFieldsUK';
import { useEffect } from 'react';
import { hasAnyAddressValues } from './addressFields.utils';
export const AddressFields = (_a) => {
    var { country } = _a, rest = __rest(_a, ["country"]);
    const dataListEnabled = useFeatureToggle('account_datalist_element');
    const addressFields = rest.showAddressCard ? ['address', 'addressSearch'] : ['address'];
    const addressValues = useWatch({ name: 'address' });
    const isRequired = rest.isRequired || hasAnyAddressValues(addressValues);
    const props = Object.assign(Object.assign({}, rest), { dataListEnabled, isRequired });
    const { clearErrors } = useFormContext();
    useEffect(() => {
        if (!isRequired) {
            clearErrors(addressFields);
        }
    }, [isRequired, clearErrors]);
    switch (country === null || country === void 0 ? void 0 : country.toUpperCase()) {
        case 'BE':
            return _jsx(AddressFieldsBE, Object.assign({}, props));
        case 'DE':
            return _jsx(AddressFieldsDE, Object.assign({}, props));
        case 'FR':
            return _jsx(AddressFieldsFR, Object.assign({}, props));
        case 'LU':
            return _jsx(AddressFieldsLU, Object.assign({}, props));
        case 'NL':
            return _jsx(AddressFieldsNL, Object.assign({}, props));
        case 'GB':
        case 'GG':
        case 'JE':
            return _jsx(AddressFieldsUK, Object.assign({}, props));
        case 'BFPO':
        case 'IE':
        case 'AU':
        case 'NZ':
            return _jsx(AddressFieldsBasicAlt, Object.assign({}, props));
        default:
            return _jsx(AddressFieldsBasic, Object.assign({}, props));
    }
};
